import { FacilityPrimaryCaseCaptureMode } from 'common/lib/model/facility/FacilitySubscriptionData';
import { observer } from 'mobx-react';
import React from 'react';
import { useState } from 'react';
import Select from 'react-select';
import { styleSelectComponent } from 'src/utils';
import styles from '../styles.module.scss';

interface PrimaryCaseCaptureModeDropdownProps {
    onChange: Function;
    selectedValue?: FacilityPrimaryCaseCaptureMode;
}

function PrimaryCaseCaptureModeDropdown(props: PrimaryCaseCaptureModeDropdownProps) {
    const options = mapPrimaryUseOptions();
    const [selected, setSelected] = useState(options.find((i) => i.value === props.selectedValue) || null);

    function mapPrimaryUseOptions() {
        const cases = Object.values(FacilityPrimaryCaseCaptureMode);
        const caseOptions = cases.map((value) => {
            let label;
            switch (value) {
                case FacilityPrimaryCaseCaptureMode.PaperDataEntry:
                    label = 'Paper Data Entry';
                    break;
                case FacilityPrimaryCaseCaptureMode.DigitalPaper:
                    label = 'Digital Paper';
                    break;
                case FacilityPrimaryCaseCaptureMode.DigitalExpress:
                    label = 'Digital Express';
                    break;
                case FacilityPrimaryCaseCaptureMode.EpicEWF:
                    label = 'Epic EWF';
                    break;
                case FacilityPrimaryCaseCaptureMode.Integration:
                    label = 'Integration';
                    break;
            }

            return { label, value };
        });

        return caseOptions.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
    }

    return (
        <Select
            value={selected}
            onChange={(s: any) => {
                setSelected(s);
                props.onChange(s || null);
            }}
            isClearable={true}
            className={styles.select}
            options={options}
            placeholder="Select Primary Case Capture Mode"
            styles={styleSelectComponent()}
        />
    );
}

export default observer(PrimaryCaseCaptureModeDropdown);
